import React from 'react';
import styled from '@emotion/styled';
import { Flex } from '@Calix-Commerce/design-system/layout';
import { Switch, Route, Redirect } from 'react-router-dom';

import { ThemeProvider, GlobalStyles } from '@Calix-Commerce/design-system/globals';

import {
  ErrorBoundary,
  Header,
  Footer,
  AuthOverlay,
  LoaderOverlay,
  Notification,
  InfoModal,
  Breadcrumb,
  GoogleTagManager,
} from 'components';
import {
  CaseManager,
  CaseDetails,
  NewCaseSearch,
  NewCaseDetails,
  NewCaseConfirmation,
  CheckoutShipping,
  CheckoutBilling,
  CheckoutReview,
} from './pages';
import GoogleAnalytics from 'components/GoogleAnalytics';

const AppStyled = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const MainContent = styled.div`
  flex-grow: 1;
`;

const MaintenancePage = () => {
  return (
    <Flex alignment="baseline" spacing="space-around">
      <div>
        <h1>Maintenance</h1>
        <p>The My Calix Store is currently undergoing maintenance and will be back up shortly.</p>
      </div>
    </Flex>
  );
};

const App = () => {
  const loadGA = process.env.REACT_APP_GOOGLE_ANALYTICS_ID !== 'false';
  const inMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

  return (
    <ErrorBoundary>
      {/* Making MaterialUI styles overridable */}
      <ThemeProvider>
        <GlobalStyles />
        <LoaderOverlay />
        <Notification />
        {inMaintenanceMode ? (
          <MaintenancePage />
        ) : (
          <>
            <AppStyled>
              <InfoModal />
              {loadGA ? <GoogleAnalytics /> : null}
              <AuthOverlay>
                <GoogleTagManager />
                <Header />
                <Breadcrumb />
                <MainContent>
                  <Switch>
                    <Route exact path="/cases/new/search" component={NewCaseSearch} />
                    <Route exact path="/cases/new/details" component={NewCaseDetails} />
                    <Route exact path="/cases" component={CaseManager} />
                    <Route exact path="/case/:caseNumber" component={CaseDetails} />
                    <Route exact path="/cases/new/checkout/shipping" component={CheckoutShipping} />
                    <Route exact path="/cases/new/checkout/billing" component={CheckoutBilling} />
                    <Route exact path="/cases/new/checkout/review" component={CheckoutReview} />
                    <Route exact path="/cases/new/confirmation" component={NewCaseConfirmation} />
                    <Redirect to="/cases" />
                  </Switch>
                </MainContent>
                <Footer />
              </AuthOverlay>
            </AppStyled>
          </>
        )}
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
